import { useTranslation } from 'react-i18next';
import { mdiAccountMinus, mdiAccountPlus } from '@mdi/js';
import { SxProps, Tooltip } from '@mui/material';

import { Button } from 'common/components/Button';
import { Icon } from 'common/components/Icon';
import { IOfferEventSubscriptionStatus } from 'graphql/types';

const buttonStyle: SxProps = {
    width: 45,
    height: 40,
    p: 0,
    '&.MuiButton-outlined': {
        p: 0,
    },
    mr: 1,
};

interface IProps {
    enrollmentStatus: IOfferEventSubscriptionStatus;
    onClickEnroll?(): void;
    onClickReject?(): void;
}

export const EnrollmentManagementTableRowButtons = ({
    enrollmentStatus,
    onClickEnroll,
    onClickReject,
}: IProps) => {
    const [translate] = useTranslation();

    const isRequestStatus =
        enrollmentStatus === IOfferEventSubscriptionStatus.Requested;
    const isWaitingListStatus =
        enrollmentStatus === IOfferEventSubscriptionStatus.Full;

    const translationKeyPrimary = 'enroll';
    const translationKeySecondary = 'reject';
    const iconPathPrimary = mdiAccountPlus;
    const iconPathSecondary = mdiAccountMinus;
    const onClickPrimary = onClickEnroll;
    const onClickSecondary = onClickReject;

    const primaryButton = (
        <Tooltip title={translate(`enrollmentsTable.${translationKeyPrimary}`)}>
            <Button
                color="primary"
                sx={buttonStyle}
                variant="contained"
                onClick={onClickPrimary}
            >
                <Icon path={iconPathPrimary} size="2.4rem" />
            </Button>
        </Tooltip>
    );

    const secondaryButton = (
        <Tooltip
            title={translate(`enrollmentsTable.${translationKeySecondary}`)}
        >
            <Button
                color="inherit"
                sx={{ ...buttonStyle, borderColor: 'divider' }}
                variant="outlined"
                onClick={onClickSecondary}
            >
                <Icon path={iconPathSecondary} size="2.4rem" />
            </Button>
        </Tooltip>
    );

    if (!isRequestStatus && !isWaitingListStatus) return null;

    return (
        <>
            {primaryButton}
            {secondaryButton}
        </>
    );
};
